function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as t } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const n = (_param)=>{
    var { color: l , size: c = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const v = t(), a = l !== null && l !== void 0 ? l : v ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ s("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: a,
                d: "M7.591 19.074c0 .308.252.56.56.56.308 0 .56-.252.56-.56V7.648a.562.562 0 00-.56-.56.562.562 0 00-.56.56v11.426zm6.896.336a.42.42 0 10.84 0v-.305c.4-.06.737-.204.992-.429.337-.291.516-.703.516-1.19 0-.589-.265-1.322-1.507-1.523v-1.489c.186.043.37.115.56.219l.006.003a.528.528 0 00.24.067.406.406 0 00.407-.406c0-.09-.031-.258-.239-.384a2.485 2.485 0 00-.974-.332v-.296a.42.42 0 10-.84 0v.306c-.823.148-1.334.73-1.334 1.566 0 .556.239 1.244 1.333 1.475v1.578a2.424 2.424 0 01-.767-.348.511.511 0 00-.269-.086.42.42 0 00-.42.414c0 .154.067.277.199.37.377.26.807.426 1.257.49v.3zm1.507-1.89c0 .384-.247.655-.666.758v-1.452c.578.143.666.415.666.693zm-2.002-2.343c0-.341.178-.583.495-.69v1.321c-.426-.152-.495-.398-.495-.63zm-3.082 4.471a.562.562 0 01-.56-.56v-7.056a.561.561 0 011.12 0v7.056c0 .31-.249.56-.56.56z"
            }),
            /* @__PURE__ */ r("path", {
                fill: a,
                d: "M18.148 21.847H5.852c-.589 0-1.107-.518-1.107-1.107V3.261c0-.568.538-1.106 1.107-1.106h7.38c.143 0 .283.056.387.154l5.462 5.182a.557.557 0 01.174.406V20.74c0 .589-.518 1.107-1.107 1.107zM5.88 20.727h12.249l.005-.006V9.004h-2.45c-.956 0-1.78-.317-2.376-.916-.597-.6-.916-1.42-.916-2.376V3.275H5.888a.085.085 0 00-.022.023v17.417a.061.061 0 00.014.011zm7.633-16.973v1.958c0 .653.204 1.2.588 1.583.384.384.933.588 1.582.588h2.183l-4.353-4.13z"
            })
        ]
    }));
}, f = n;
export { f as default };
